<template>
    <div class="popup rd-dialog rd-prize rd-wheel-prize">
        <van-popup :value="show" @click-overlay="close">
            <div class="content" @click.stop="close">
                <statusBar></statusBar>
                <div class="header">
                    <!-- <div>{{ $t("agent.AgentPanel") }}</div> -->
                    <div class="close">
                        <i class="iconfont icon-s-cuowu-guanbi" @click.stop="close"></i>
                    </div>
                </div>
                <div class="main-content">
                    <img v-if="show" v-theme-art="$themeImage('common.gift') || require('@/assets/scratchCards/win.gif')" class="win_img" :src="$themeImage('common.gift') || require('@/assets/scratchCards/win.gif')" />
                    <div v-if="isShowWinItem" class="win_item">
                        <img v-theme-art="logoUrl" class="logo" :src="logoUrl" />
                        <div class="line line1">{{ winItem.title }}</div>
                        <div class="line line2">{{ winItem.message }}</div>
                        <div class="win_content">
                            <img v-theme-art="winItem.imgUrl" class="win_icon" :src="winItem.imgUrl" />
                            <div class="win_money">{{ CurrencyType }} {{ winItem.raspaAmt }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import statusBar from '@/components/statusBar'
export default {
    name: 'WinPopup',
    components: { statusBar },
    data() {
        return {
            show: false,
            isShowWinItem: false,
            winItem: {}
        }
    },
    computed: {
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        }
    },
    methods: {
        open(item) {
            const that = this
            that.winItem = item
            that.show = true
            const showTimeOut = setTimeout(() => {
                that.isShowWinItem = true
                clearTimeout(showTimeOut)
            }, 1100)
        },
        close() {
            this.show = false
            this.isShowWinItem = false
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

$turntable2-popup-win-border-color: $border-component-soft-color;
$turntable2-popup-win-bg: rgba($bg-component-dark-color, .8);

.popup {

    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;

        .content {
            // background: $bg-component-overlay-color;
            width: 100%;
            height: 100%;
            border-radius: .24rem;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            .header {
                display: flex;
                height: 76px;
                padding: 0 30px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                // background: $bg-popup-navbar-color;

                &>div:first-child {
                    font-size: .26rem;
                    font-weight: bold;
                    color: $font-color;
                }

                .close {
                    color: $font-iconfont-color;
                    font-size: .6rem !important;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s;
                    float: right;
                    .iconfont{
                        font-size: .3rem !important;
                    }

                    &:hover {
                        color: $font-color;
                        rotate: -180deg;
                    }
                }
            }
            .main-content{
                width: 100%;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                position: relative;
                .win_img{
                    width: 5.4rem;
                    height: 5.4rem;
                }
                .win_item{
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    padding-bottom: 4rem;
                    .logo{
                        height: 1rem;
                        width: auto;
                        margin-bottom: .08rem;
                    }
                    .line{
                        color: $font-color;
                        text-shadow: $font-color 0px 0px 22.5573px;
                        font-size: .24rem;
                    }
                    .line1{
                        text-transform: uppercase;
                        font-weight: bold;
                        font-size: .36rem;
                    }
                    .win_content{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 3.2rem;
                        padding: .32rem;
                        border: 1px solid $turntable2-popup-win-border-color;
                        border-radius: .2rem;
                        background: $turntable2-popup-win-bg;
                        margin-top: .98rem;
                        .win_icon{
                            width: auto;
                            height: .58rem;
                            margin-right: .3rem;
                        }
                        .win_money{
                            color: $font-component-muted-color;
                            font-size: .3rem;
                        }
                    }
                }
            }
        }
    }
}</style>
